<div class="right-navigation" *ngIf="hasSections">
  <h5 class="right-nav-title">{{ 'HEADER.ONTHISPAGE' | translate }}</h5>
  <nav>
    <ul class="list-unstyled">
      <li *ngFor="let section of pageSections" [ngClass]="{'faq-right-nav': addDotForFAQ === true}">
        <a 
          href="javascript:void(0)" 
          (click)="scrollToSection(section.id)"
          [class.active]="currentSectionId === section.id"
        >
          {{ section.rightNavTitle }}
        </a>
      </li>
    </ul>
  </nav>
</div>